// @flow
export const REFERENCE_ENTRY = '/';
export const COLLECTIONS = '/collections';
export const COLLECTION = '/collections/:collectionId';
export const SEARCH = '/search';
export const ERROR = '/error';
